<template>
  <v-card light height="100" width="280">
    <v-card-title class="pt-1">
      {{title}}
    </v-card-title>
    <v-card-subtitle>
      {{typeof fact != "string" ? Intl.NumberFormat('de-DE').format(fact) : fact}}
    </v-card-subtitle>
    <i class="position-absolute pos-right pos-bottom opacity-35 mb-1 mr-1" :class="icon" style="font-size:4rem"></i>
    <v-btn
      class="position-absolute pos-right pos-top mt-2 mr-2 px-0"
      text
      small
      icon
      @click="$emit('borrar_widget')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-card-actions style="min-height:52px;" class="mt-n5 pb-0">
      <slot name="barra"></slot>
      <v-btn
        color="secondary"
        text
        @click="showMore = true"
        v-show="action"
      >
        detalles
      </v-btn>

    </v-card-actions>
    <v-dialog
      v-model="showMore"
      max-width="500"
      v-if="action"
    >
      <v-card light>
        <slot></slot>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="showMore = false"
          >
            cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>


</template>

<script>
export default {
  props:{
    title:{
      type: String,
      required: true
    },
    fact:{
      required: true
    },
    icon:{
      type: String,
      required: true
    },
    action:{
      type: Boolean,
      required: false,
      default: true
    }
  },
  data(){
    return {
      showMore:false
    };
  }
}
</script>

<style>
</style>
